// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgHelpIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path
      fillRule="evenodd"
      d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2m2.943 4.482Q13.885 5.5 12.03 5.5q-1.374 0-2.357.536-.982.535-1.503 1.321-.39.572.112.91l.853.572q.483.34.798-.089.836-1.107 1.911-1.107.723 0 1.15.393.446.393.446.964 0 .5-.39 1.09-.371.57-.816 1.035-.445.446-.835 1.09-.372.643-.371 1.231v.393q0 .161.111.268.11.107.26.107h1.633q.147 0 .26-.089a.36.36 0 0 0 .11-.268v-.125q0-.445.409-1 .408-.57.89-1.053a5.6 5.6 0 0 0 .89-1.268q.41-.786.409-1.607 0-1.357-1.057-2.322m-3.878 11.554q.482.465 1.169.464.667 0 1.15-.464.482-.465.482-1.107 0-.66-.482-1.125a1.6 1.6 0 0 0-1.15-.465q-.687 0-1.17.465-.481.464-.482 1.125 0 .642.483 1.107"
    />
  </g>
);
export default SvgHelpIcon;
SvgHelpIcon.displayName = 'SvgHelpIcon';
